export const LOGIN_MODEL ={
    email: '',
    password: '',
    code: null,
    toRegister: function (data) {
        return {
            email:data?.email,
            password:data?.password,
            code:data?.otp
        }
    },
}

export const BACK_TO_UI_LANG = {
    EN: "en",
    ES: "sp",
    FR: "fr",
};

export const UI_TO_BACK_LANG = {
    en: "EN",
    sp: "ES",
    fr: "FR",
};

export const TAB_INDEX = {
    ONE: 1, //enter email
    TWO: 2, //otp verification
    THREE: 3, // create new password
    FOUR: 4, //success view
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8
};

export const STEP_MODEL = {
    CHOICE:{
        TOTAL:1,
        NAME:'CHOICE',
        STEPS:{
            VALIDATED:1
        }
    },
    EMAIL: {
        TOTAL: 3,
        NAME: 'EMAIL',
        STEPS: {
            OTP: 1,
            CREATE_PASSWORD: 2,
            SUCCESS: 3
        }
    },
    APP: {
        TOTAL: 3,
        NAME: 'APP',
        STEPS: {
            OTP: 1,
            CREATE_PASSWORD: 2,
            SUCCESS: 3
        }
    },
}
